"use client";
import { jsx as m } from "react/jsx-runtime";
import s from "clsx";
import { Box as n } from "../../blocks/base/Base.js";
import { s as r } from "../../Button.module-C3Ja-wjg.js";
const i = ({
  text: o,
  color: t = "orange",
  error: e,
  ...a
}) => /* @__PURE__ */ m(
  n,
  {
    gap: 4,
    row: !0,
    center: !0,
    className: s(r.info_tag, r[t], {
      [r._error]: e
    }),
    ...a,
    children: o
  }
);
i.displayName = "ButtonTag";
export {
  i as ButtonTag
};
